module.exports = __webpack_public_path__ + "img/8.503f48d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8.jpg
// module id = 212
// module chunks = 1